<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:error="errorHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import ClaimLimitAdjustmentForm from "../../../components/claim/claimlimitadjustment/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": ClaimLimitAdjustmentForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('claimlimitadjustmentrecord.createnewclaimlimitadjustment'),
      pageTitleValue: "",
      formData: {
        staffid: null,
        clmtypeid: null,
        clmtypedesc: null,
        clmtype: null,
        clmlimitadjtypeid: null,
        adjamount: null,
        valuedate: null,
        clmadjreasonid: null,
        remark: null,
        stamp: 0,
        userid: this.$store.getters.userId,
      },


      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      // console.log('form new', payload: this.formData})

      this.$store.dispatch('post', {url: "/claimlimitadjustment/create", payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "claimlimitadjustmentlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    cancelHandler() {
      this.$router.push({ name: "claimlimitadjustmentlist" });
    },
  },
};
</script>